import React, { useContext, useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { observer } from 'mobx-react-lite';
import StoreContext from './store-context';

export const InnerApp = observer(({ UnauthenticatedComponent, theme, globalComponents }) => {
    const contextValue = useContext(StoreContext);

    console.log('Do we have contextValue?', !!contextValue);
    if (!contextValue) {
        console.log('No contextValue');
        return null;
    }

    const appToRender = <UnauthenticatedComponent />;

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router>
                {globalComponents}
                {appToRender}
            </Router>
        </ThemeProvider>
    );
});

function UnauthenticatedAppWithStore({ UnauthenticatedComponent, createAppStateStore, theme, globalComponents }) {
    const [appStateStore, setAppStateStore] = useState(null);

    useEffect(() => {
        console.log('UnauthenticatedAppWithStore::useEffect');
        setAppStateStore(createAppStateStore());
    }, []);

    if (!appStateStore) {
        return null; // or a loading indicator
    }

    return (
        <StoreContext.Provider value={appStateStore}>
            <InnerApp
                UnauthenticatedComponent={UnauthenticatedComponent}
                theme={theme}
                globalComponents={globalComponents}
            />
        </StoreContext.Provider>
    );
}

export default observer(UnauthenticatedAppWithStore);
